import LifestyleMembershipPanel from "./panels/LifestyleMembershipPanel";


const tabRoutes = [
  {
    name: "Lifestyle Membership",
    path: "/tstyle-member",
    component: <LifestyleMembershipPanel />
  }
  // ,{
  //   name: "Member Home",
  //   path: "/member-home",
  //   component: <h1>Member Home Tab</h1>,
  // },
  // {
  //   name: "Family Members",
  //   path: "/family-members",
  //   component: <h1>Family Members Tab</h1>,
  // },
  // {
  //   name: "LifeStyle Membership",
  //   path: "/lifeStyle-membership",
  //   component: <h1>LifeStyle Membership Tab</h1>,
  // },
  // {
  //   name: "LifeStyle Activities",
  //   path: "/lifeStyle-activities",
  //   component: <h1>LifeStyle Activities Tab</h1>,
  // }
];

export default tabRoutes;

